module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Fragebogen ro.e518a64b.svg";